<template>
  <div id="app">

    <!-- 🔥 SOLO PREGUNTAR -->
    <template v-if="pantalla === 'preguntar'">
      <Preguntar @idioma-seleccionado="establecerIdioma" />
    </template>

    <!-- 🔥 CONTENIDO -->
    <template v-else-if="pantalla === 'contenido'">

      <!-- ESPAÑOL -->
      <template v-if="idiomaSeleccionado === 'es'">
        <Componentep 
          v-if="isSmallScreen"
          :id-invitado="idInvitado"
        />
        <PantallaG v-else />
      </template>

      <!-- INGLÉS -->
      <template v-else-if="idiomaSeleccionado === 'en'">
        <ComponentePingles 
          v-if="isSmallScreen"
          :id-invitado="idInvitado"
        />
        <PantallaG v-else />
      </template>

    </template>

  </div>
</template>

<script>
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

import Preguntar from './components/preguntar.vue'
import Componentep from './components/contenedor.vue'
import ComponentePingles from './components/ingles/contenedor_ingles.vue'
import PantallaG from './components/pantallas_g.vue'

export default {
  components: {
    Preguntar,
    Componentep,
    ComponentePingles,
    PantallaG,
  },
  setup() {
    const route = useRoute()

    const idInvitado = ref(Number(route.params.idInvitado) || undefined)
    const isSmallScreen = ref(window.innerWidth < 768)

    // 🔥 INICIA DIRECTO EN PREGUNTAR
    const pantalla = ref('preguntar')
    const idiomaSeleccionado = ref(null)

    // 🔥 CUANDO ELIGEN IDIOMA
    const establecerIdioma = (idioma) => {
      idiomaSeleccionado.value = idioma
      pantalla.value = 'contenido'
    }

    watch(() => route.params.idInvitado, (newId) => {
      idInvitado.value = Number(newId)
    })

    window.addEventListener('resize', () => {
      isSmallScreen.value = window.innerWidth < 768
    })

    return {
      idInvitado,
      isSmallScreen,
      pantalla,
      idiomaSeleccionado,
      establecerIdioma,
    }
  }
}
</script>